import { useContext, useState } from "react";
import { Box, Card } from "@material-ui/core";
import { DashboardContext } from "..";
import { blue, purple, red, deepPurple, green, deepOrange } from "@material-ui/core/colors";

import LocalLibraryIcon from '@material-ui/icons/People';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import SchoolIcon from '@material-ui/icons/School';
import Board from "./Board";
import { CircularProgress, Snackbar, Tab, Tabs } from "@material-ui/core";
import TabPanel from "../../../ReusableComponents/TabPanel";
import { useHistory } from "react-router-dom";
import moment from "moment";
import TextReadMore from "../../../ReusableComponents/TextReadMore";

const Cards = props => {

    const dashboard = useContext(DashboardContext);
    const [activeTab, setActiveTab] = useState(0);
    const history = useHistory();

    return (
        <Box
            component={Card}
            width="100%"
            padding={1.5}
            marginBottom={5}
            elevation={1}
        >
            {dashboard.isLoading==true &&   <div className="row" style={{ margin: 0 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                                                <CircularProgress />
                                            </div></div>}
            {dashboard.isLoading==false && <div>

            <div className="flex jcsb">
                <h4 className="header">{dashboard?.faculdade?.name}</h4>
            </div>
            <div style={{ flexWrap: 'wrap', display: 'flex', width: '100%' }}>

                <Board
                    icon={<LocalLibraryIcon />}
                    color={purple}
                    content={{
                        title: "Candidatos",
                        quantity: dashboard?.alunos
                    }}
                    links={[
                        { label: "Gerenciar candidatos", link: "/instituicao/show/" + dashboard?.faculdade?.id + "?tab=3" }
                    ]}
                />
                <Board
                    icon={<PeopleAltIcon />}
                    color={red}
                    content={{
                        title: "Fiscais",
                        quantity: dashboard?.fiscais
                    }}
                    links={[
                        { label: "Gerenciar fiscais", link: "/instituicao/show/" + dashboard?.faculdade?.id + "?tab=2" },
                    ]}
                />
                <Board
                    icon={<SchoolIcon />}
                    color={blue}
                    content={{
                        title: "Corretores",
                        quantity: dashboard?.corretores
                    }}
                    links={[
                        { label: "Gerenciar corretores", link: "/instituicao/show/" + dashboard?.faculdade?.id + "?tab=1" },
                    ]}
                />

                <Board
                    icon={<LocalLibraryIcon />}
                    color={deepPurple}
                    content={{
                        title: "Candidatos online",
                        quantity: dashboard?.alunos_online?.length
                    }}
                links={[
                    { label: "Gerenciar candidatos", link: "/instituicao/show/" + dashboard?.faculdade?.id + "?tab=3" }
                ]}
                />
                <Board
                    icon={<PeopleAltIcon />}
                    color={deepOrange}
                    content={{
                        title: "Fiscais online",
                        quantity: dashboard?.fiscais_online?.length
                    }}
                links={[
                    { label: "Gerenciar fiscais", link: "/instituicao/show/" + dashboard?.faculdade?.id + "?tab=2" },
                ]}
                />
            </div>
            <br />

            <Tabs
                value={activeTab}
                onChange={(_, value) => {
                    setActiveTab(value);
                    history.push({ search: `?tab=${value}` });
                }}
                style={{ backgroundColor: "#ececf1" }}
                indicatorColor="primary"
                textColor="primary"
                variant={"scrollable"}
                scrollButtons={"on"}

            >
                {dashboard?.processos?.map((item, id) => {
                    return (
                        <Tab key={id} label={item.name} />
                    );
                })}


            </Tabs>

            {dashboard?.processos?.map((processo, id) => {
                return (
                    <TabPanel key={id} value={activeTab} index={id}>
                        <TextReadMore title="Início: " element="div" limit={1000} style={{ width: "100%", marginBottom: 10, whiteSpace: 'pre' }}>
                            {moment(processo.inicio).format('DD/MM/YYYY HH:mm')}
                        </TextReadMore>
                        <TextReadMore title="Encerramento: " element="div" limit={1000} style={{ width: "100%", marginBottom: 10, whiteSpace: 'pre' }}>
                            {moment(processo.fim).format('DD/MM/YYYY HH:mm')}
                        </TextReadMore>

                        <b style={{ marginRight: "2px" }}>Status: {moment().format('YYYY-MM-DD HH:mm') < moment(processo.fim).format('YYYY-MM-DD HH:mm') && moment().format('YYYY-MM-DD HH:mm') > moment(processo.inicio).format('YYYY-MM-DD HH:mm') ? <span style={{ color: 'green', fontWeight: 'normal' }}>Andamento</span> : (moment().format('YYYY-MM-DD HH:mm') >= moment(processo.fim).format('YYYY-MM-DD HH:mm') ? <span style={{ fontWeight: 'normal', color: 'green' }}>Finalizado</span> : <span style={{ fontWeight: 'normal', color: 'darkgoldenrod' }}>Não iniciado</span>)}</b>
                        <hr />
                        <div>
                            <p style={{ marginBottom: 10 }}><b style={{ marginRight: "2px" }}>Total fiscais: <span style={{ fontWeight: 'normal' }}>{processo.total_fiscais}</span></b></p>
                            <p style={{ marginBottom: 10 }}><b style={{ marginRight: "2px" }}>Total corretores: <span style={{ fontWeight: 'normal' }}>{processo.total_corretores}</span></b></p>

                            <p style={{ marginBottom: 10 }}><b style={{ marginRight: "2px" }}>Total candidatos: <span style={{ fontWeight: 'normal' }}>{processo.total_alunos}</span></b></p>
                            
                            <p style={{ marginBottom: 10 }}><b style={{ marginRight: "2px" }}>Candidatos que fizeram login: <span style={{ fontWeight: 'normal' }}>{processo.alunos_login}</span></b></p>
                            <p style={{ marginBottom: 10 }}><b style={{ marginRight: "2px" }}>Candidatos que acessaram a tela de termos: <span style={{ fontWeight: 'normal' }}>{processo.tela_termos}</span></b></p>
                            <p style={{ marginBottom: 10 }}><b style={{ marginRight: "2px" }}>Candidatos que acessaram a tela de avaliação não iniciada: <span style={{ fontWeight: 'normal' }}>{processo.tela_avaliacao_nao_iniciada}</span></b></p>
                            
                            <p style={{ marginBottom: 10 }}><b style={{ marginRight: "2px" }}>Candidatos que acessaram a tela de aceite de regras: <span style={{ fontWeight: 'normal' }}>{processo.entraram_alunos_aceite}</span></b></p>
                            <p style={{ marginBottom: 10 }}><b style={{ marginRight: "2px" }}>Candidatos que acessaram a tela de avaliação em andamento: <span style={{ fontWeight: 'normal' }}>{processo.entraram_alunos_prova}</span></b></p>
                            <p style={{ marginBottom: 10 }}><b style={{ marginRight: "2px" }}>Candidatos que acessaram a tela de avaliação finalizada: <span style={{ fontWeight: 'normal' }}>{processo.tela_avaliacao_finalizada}</span></b></p>

                            <p style={{ marginBottom: 10 }}><b style={{ marginRight: "2px" }}>Candidatos ausentes: <span style={{ fontWeight: 'normal' }}>{processo.ausentes_alunos}</span></b></p>
                            <p style={{ marginBottom: 10 }}><b style={{ marginRight: "2px" }}>Candidatos que acessaram e não finalizaram: <span style={{ fontWeight: 'normal' }}>{processo.nao_finalizaram_alunos}</span></b></p>
                            <p style={{ marginBottom: 10 }}><b style={{ marginRight: "2px" }}>Candidatos que acessaram e finalizaram: <span style={{ fontWeight: 'normal' }}>{processo.finalizaram_alunos}</span></b></p>






                        </div>

                        <hr />

                        <p style={{ marginTop: 10, marginBottom: 0 }}><b >Salas:</b></p>

                        <div className="table-rep-plugin">
                            <div className="table-responsive mb-0" data-pattern="priority-columns">
                                <table id="tech-companies-1" className="table table-striped">
                                    <thead>
                                        <tr>

                                            <th>Sala</th>
                                            <th>Nº candidatos</th>
                                            <th>Candidatos Online</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {processo.salas.map((item, id) => (

                                            <tr key={id}>
                                                <td>Sala {item.numero}</td>
                                                <td>{item.total}</td>
                                                <td>{item.online}</td>



                                            </tr>
                                        ))}

                                    </tbody>
                                </table>

                            </div>
                        </div>
                        {processo.salas.length == 0 && <div className="row w-100">
                            <div className="col-12">
                                <p style={{ textAlign: 'center' }}>Nenhuma sala encontrada</p>

                            </div>
                        </div>}
                    </TabPanel>
                );

            })}
            </div>}


        </Box>
    );
}

export default Cards;